import React from 'react';
import { Row, Col, Divider } from 'antd';

interface ReportSummaryProps {
  children: React.ReactNode;
}

export function ReportSummary(props: ReportSummaryProps) {
  return (
    <div className="modal-display" style={{ marginTop: '15px', backgroundColor: '#fff', border: '1px solid #d9d9d9', borderRadius: '15px', padding: '10px' }}>
      <Row justify="start" style={{ fontWeight: 'bold', marginBottom: '15px' }}>
        Summary
      </Row>
      {props.children}
    </div>
  );
}

interface ItemProps {
  left: React.ReactNode;
  right: React.ReactNode;
}
function Item(props: ItemProps) {
  return (
    <>
      <Row justify="space-between">
        <Col>{props.left}</Col>
        <Col>{props.right}</Col>
      </Row>
      <Divider dashed />
    </>
  );
}

ReportSummary.Item = Item;
